const _ = require('lodash');

function assignShopperDetails(details) {
    this.currentUser.isGuest = !details || details.IsGuest;
    _.assign(this, details);
    return this;
}

function assignShopperPreferences(preferences) {
    this.preferences = {
        EnableAccessibleOptions: preferences ? preferences.EnableAccessibleMenu : false
    };
    _.assign(this.preferences, preferences);

    return this;
}

function synchCurrentUser() {
    const shopper = this;
    const shopperDetails = {
        id: shopper.Id,
        email: shopper.Email,
        encryptedEmail: shopper.EncryptedEmail,
        encryptedShopperId: shopper.EncryptedShopperId,
        firstName: shopper.FirstName,
        lastName: shopper.LastName,
        phone: shopper.Phone,
        fullName: `${shopper.FirstName} ${shopper.LastName}`,
        isGuest: shopper.IsGuest,
        dateOfBirth: shopper.DateOfBirthInput,
        age: !_.isNull(shopper.DateOfBirthInput) ? this._ageCalculatorService.calculate(shopper.DateOfBirthInput) : 0,
        hasEdrCard: shopper.HasEdrCard,
        edrNumber: shopper.EdrNumber,
        orderCount: shopper.OrderCount,
        communicationPreferences: shopper.CommunicationPreferences,
        numberOfItemsInWatchList: shopper.NumberOfItemsInWatchList,
        isIdVerified: shopper.IsIdVerified && !shopper.ChangedSinceVerified,
        changedSinceVerified: shopper.ChangedSinceVerified,
        enableProactiveIDCheck: shopper.EnableProactiveIDCheck,
        proactiveIdVerificationDetail: shopper.ProactiveIdVerificationDetail
    };

    this._currentUserSvc.set(shopperDetails);
    return this;
}

function fetchLastOrder(shopper) {
    if (!shopper.currentUser.isGuest) {
        return this.getLastOrder();
    }
}

/**
 *
 * @param status
 * @param bookingStatus
 * @param deliveryMethod
 * @returns {*} friendly name for the status of the order
 */
function cleanOrderStatusLabel(status, bookingStatus, deliveryMethod) {
    let label;
    const LABEL_PACKED = 'Packed',
          LABEL_DELIVERED = 'Delivered',
          LABEL_COLLECTED = 'Collected',
          METHOD_DELIVERY = 'Delivery',
          METHOD_PICKUP = 'Pickup';

    //Order placed
    if (bookingStatus === 'DeliveryFailed') {
        //C&C: order collected
        label = 'Delivery attempted';
    } else if (bookingStatus === 'WithDriver' || bookingStatus === 'AtCustomer') {
        //Delivery: order with driver
        label = 'It\'s on the way!';
    } else if (bookingStatus === LABEL_DELIVERED) {
        //Delivery: order has been delivered
        label = LABEL_DELIVERED;
    } else if (status === 'Placed') {
        label = 'We\'re on it!';
    } else if ((status === LABEL_COLLECTED && bookingStatus === null && deliveryMethod === METHOD_DELIVERY)
            || (status === LABEL_PACKED && bookingStatus === 'DeliveryRequested')
            || (status === LABEL_PACKED && deliveryMethod === METHOD_DELIVERY)) {
        //Delivery: order packed
        label = 'Ready to go!';
    } else if (status === LABEL_PACKED && bookingStatus === 'DriverAssigned') {
        //Delivery: order driver assigned
        label = 'Driver booked';
    } else if (status === LABEL_PACKED && deliveryMethod === METHOD_PICKUP) {
        //C&C: order ready for collection
        label = 'Ready to pick up!';
    } else if (status === LABEL_COLLECTED && deliveryMethod === METHOD_PICKUP) {
        //C&C: order collected
        label = LABEL_COLLECTED;
    } else {
        //Order cancelled/default status
        label = status;
    }

    return label;

}


function ShopperService(Restangular, CurrentUserService, SessionContext, AgeCalculatorService, $rootScope) {
    this._api = Restangular.one('shopper');
    this._myAccountApi = Restangular.one('myaccount');
    this._emailNotification = Restangular.one('EmailNotification');
    this.preferences = {};
    this.recentOrders = {};
    this.isLastOrderDetailsReady = false;
    this._currentUserSvc = CurrentUserService;
    this._ageCalculatorService = AgeCalculatorService;
    this.currentUser = CurrentUserService.get();
    this.$rootScope = $rootScope;
    this.hasRecentOrder = false;
    this.labToken = ''; // will be available when redirect from LAB

    if (!this.currentUser.isGuest || SessionContext.isGuestLoggedIn(this.currentUser.id)) {
        this.getCurrentShopperDetails();
    }
}

ShopperService.prototype.setIdVerificationToken = function (token) {
    sessionStorage.setItem('LabToken',token);
};

ShopperService.prototype.getIdVerificationToken = function () {
    return sessionStorage.getItem('LabToken');
};

ShopperService.prototype.setIsRedirectedFromLab = function (value) {
    sessionStorage.setItem('IsRedirectedFromLab',value);
};

ShopperService.prototype.getIsRedirectedFromLab = function () {
    return sessionStorage.getItem('IsRedirectedFromLab');
};

ShopperService.prototype.setCheckoutIdVerificationToken = function (token) {
    this.labToken = token;
};

ShopperService.prototype.getCurrentShopperDetails = function () {
    return this._api.get()
        .then(assignShopperDetails.bind(this))
        .then(fetchLastOrder.bind(this))
        .then(synchCurrentUser.bind(this))
        .then((response) => {
            this.$rootScope.$broadcast('shopper:init', response);
            return response;
        })
        .then((response) => {
            if (this.recentOrders && this.recentOrders.Status) {
                const bookingStatus = this.recentOrders.DeliveryBookingList.length ? this.recentOrders.DeliveryBookingList[0].BookingStatus : null;
                this.recentOrders.StatusLabel = cleanOrderStatusLabel(this.recentOrders.Status, bookingStatus, this.recentOrders.DeliveryMethod);
            }
            return response;

        });
};

ShopperService.prototype.getCurrentShopperPreferences = function () {
    return this._myAccountApi.one('ShopperPreferences').get().then(assignShopperPreferences.bind(this));
};

ShopperService.prototype.updateShopperPersonalDetails = function (shopper) {
    return this._myAccountApi.one('PersonalDetails').doPOST(shopper);
};

ShopperService.prototype.updateShopperBusinessDetails = function (shopper) {
    return this._myAccountApi.one('BusinessDetails').doPOST(shopper);
};

ShopperService.prototype.notifyEnableDelivery = function () {
    return this._emailNotification.one('SetNotification').doPOST({ NotifiedReason: 'Enable Delivery' });
};

ShopperService.prototype.getLastOrder = function () {
    this.isLastOrderDetailsReady = false;

    return this._api.one('LastOrder').get().then((response) => {
        if (response !== undefined) {
            this.recentOrders = response;
            this.isLastOrderDetailsReady = true;
            this.hasRecentOrder = true;
            this.recentOrders.StatusLabel = cleanOrderStatusLabel(response.Status, response.bookingStatus, response.DeliveryMethod);
        }

    });
};

ShopperService.prototype.getOrderById = function (orderId) {
    this.isLastOrderDetailsReady = false;

    return this._api.one('Orders', orderId).get().then();
};

ShopperService.prototype.getOrderHistory = function (pageNumber, pageSize) {
    return this._api.one('Orders').get({ SortType: 'DatePlacedDesc', pageNumber, pageSize }).then(response => {
        _.each(response.Items, (order) => {
            order.Status = cleanOrderStatusLabel(order.Status, order.BookingStatus, order.DeliveryMethod);
        });
        return response;
    });
};

ShopperService.prototype.shouldDisplayDeliveryPassNavLink = function () {
    return this._myAccountApi.one('DeliverySaverNavLinkEnabled').get();
};

ShopperService.prototype.setPreferenceEnableAccessibility = function (newValue) {
    return this._myAccountApi.one('ShopperPreferences/EnableAccessibleMenu').doPOST({ Value: newValue });
};

ShopperService.prototype.reorder = function (orderId) {
    return this._api.post('ReOrders/' + orderId);
};

ShopperService.prototype.setNotificationPreferences = function (emailOptIn, smsOptIn) {
    return this._api.one('notificationPreferences').doPOST({
        EmailOptIn: emailOptIn,
        SmsOptIn: smsOptIn
    });
};

ShopperService.prototype.setNotification = function (data) {
    return this._emailNotification.one('SetNotification').doPOST(data);
};

ShopperService.prototype.setGuestDetails = function (details) {
    return this._api.one('GuestDetails').doPOST(details);
};

ShopperService.prototype.setIncludeBackOrder = function (val) {
    return this._api.one('IncludeBackOrder').doPOST({ IncludeBackOrder: val });
};

ShopperService.prototype.getIncludeBackOrder = function () {
    return this._api.one('IncludeBackOrder').get();
};

ShopperService.prototype.initIdVerification = function (url) {
    this.setIdVerificationToken('');
    return this._api.one('InitiateIdVerification').doPOST({ returnUrl: url });
};

ShopperService.prototype.getIdVerificationDetails = function () {
    const labToken = this.getIdVerificationToken();
    if (!labToken) {
        return Promise.resolve({
            FirstName: '',
            LastName: '',
            DateOfBirth: undefined,
            Status: ''
        });
    }
    return this._api.one('GetIdVerificationDetails').get({ token: labToken });
};

ShopperService.prototype.getCheckoutIdVerificationDetails = function () {
    const labToken = this.labToken;
    if (!labToken) {
        return Promise.resolve({
            FirstName: '',
            LastName: '',
            DateOfBirth: undefined,
            Status: ''
        });
    }
    return this._api.one('GetIdVerificationDetails').get({ token: labToken });
};

ShopperService.prototype.updateMemberDetails = function () {
    return this._api.one('UpdateMemberDetailsFromIdCheck').doPOST({ });
};

/**
 * ShopperService.checkEmail
 * @description checked provided email is an existing user or not
 * @method checkEmail
 * @param {Object} data - data object to be post to API
 * @param {string} data.Email - email address
 * @param {string} data.RecaptchaToken - Google RecaptCha V3 token
 * @returns {Promise}
 */
ShopperService.prototype.checkEmail = function (data) {
    const emailData = data || {};
    return this._api.one('CheckEmail').doPOST(emailData);
};

module.exports = ShopperService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shopper/shopper-service.js
 **/